jQuery(function($){
  var searchSystem = {
    init: function(){
      searchSystem.initSearchSystem();
    },
    initSearchSystem: function(){

    var trottle = (function() {
      var timer = 0;
      return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();

    $('input[name=tech_search]').on( 'keyup', function(e) {
      var keycode = e.keyCode;
      var valid =
        (keycode > 47 && keycode < 58)   ||
        keycode === 32 || keycode === 13 ||
        keycode === 8 || keycode === 46  ||
        (keycode > 64 && keycode < 91)   ||
        (keycode > 95 && keycode < 112)  ||
        (keycode > 185 && keycode < 193) ||
        (keycode > 218 && keycode < 223);

        if(valid) {
          $this = $(this);
          $this.parent().find('.ot-search__dropdown').stop(1,1).fadeOut(200);

          trottle(function () {
            var search_str = $this.val();
            $('input[name=tech_search]').val(search_str);

            if (search_str.length >= 3) {
              var nce = $this.data('nce');
              $('.ot-search__loading').stop(1,1).fadeIn(200);
              jQuery.post(
                ajaxurl + "?action=search_autocompletion",
                "s=" + search_str + "&_nce=" + $this.data('nce'),
                function (response) {
                  if (response.status == 'ok') {
                    $('.ot-search__dropdown').html(response.html);
                    $this.parent().parent().find('.ot-search__dropdown').stop(1,1).fadeIn(200);
                  }
                  $('.ot-search__loading').stop(1,1).fadeOut(200);
                }, 'json'
              );
            }
          }, 500);
        }
      });

      $('.ot-search__dropdown').on('click', 'li', function(e) {
        var sinput = $(this).data('sinput');
        if(sinput !== undefined) {
          e.preventDefault();
          $('input[name=tech_search]').val(sinput);
          $('.ot-search__dropdown').stop(1,1).fadeOut(200);
        }
      });

    }
  };
  $(document).ready(searchSystem.init);
});

